import { createFileRoute } from '@tanstack/react-router';
import React from 'react';

import { useGame } from '~/apis';
import { useTranslation } from '~/app';
import { getRouteHead } from '~/app/routeHead';
import { ROUTE_GAMES } from '~/app/routes';
import SpectateGame from '~/replay/SpectateGame';

export const Route = createFileRoute('/freegames/$id/spectate')({
  component: FreeGameSpectateRoute,
  head: ({ params }) => getRouteHead({ title: params.id ? `Spectate · ${params.id}` : 'Spectate' }),
});

function FreeGameSpectateRoute() {
  const { id } = Route.useParams();
  const { data: gameState, isLoading, error } = useGame(id, { enabled: !!id });

  if (!id || error || (!isLoading && !gameState)) {
    return <SpectateByGameError />;
  }

  if (isLoading || !gameState) {
    return <SpectateByGameLoading />;
  }

  return <SpectateGame gameId={id} gameState={gameState} closeTo={ROUTE_GAMES} />;
}

function SpectateByGameLoading() {
  const { t } = useTranslation();
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-gray-100">
      <p className="text-gray-600">{t('replay_loading')}</p>
    </div>
  );
}

function SpectateByGameError() {
  const { t } = useTranslation();
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-gray-100 p-4">
      <div className="w-full max-w-md rounded-lg border border-gray-300 bg-white p-6 shadow-sm">
        <h1 className="mb-2 text-lg font-semibold text-gray-900">
          {t('games_replay_notAvailable')}
        </h1>
        <p className="mb-6 text-sm text-gray-600">{t('games_history_error')}</p>
      </div>
    </div>
  );
}
